import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { calculateGroupPL } from './utils/groupCalculation';

const GroupProfitLoss = React.memo(({ positionList, symbolId, side }) => {

    const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);
    const symbols = useSelector((state) => state.updateSymbol.symbols);

    const totalGroupPL = useMemo(() => {
        return calculateGroupPL({ positionList, symbolId, side, symbols, allSymbolParams });
    }, [positionList, symbolId, side, allSymbolParams, symbols]);

    return <span className={`${totalGroupPL < 0 ? 'red' : 'green'}`}>{totalGroupPL}</span>;
});

export default GroupProfitLoss;
